export enum QueryKeys {
  getPaymentMehods,
  getLeaseCharges,
  getLeases,
  getLeaseCashLedger,
  getLeaseBalance,
  getResident,
  getAddress,
  getAutoPay,
  getTermsAndConditionsAcceptance,
  getActiveTermsOfServiceVersion,
  getActivePrivacyPolicyVersion,
  postComputeTransaction,
  getWorkOrders,
  getApiLoginId,
  getMediaAlbums,
  getEntityMedia,
  getManagementFeePolicies,
  getRecurrentChargesByLeaseId,
  getLeaseChargesByLeaseId,
  getPrepayment,
  getActiveLeaseSettingByLeaseId,
  getPropertyContact,
}
